module.exports = __webpack_public_path__ + "static/img/07.94b1f992.png";